module.exports = __webpack_public_path__ + "media/images/button_login-a11069259f33056b9ac2f96ec2634cd5.svg";